<template>
  <div class="hero-body">
    <section class="hero is-large is-primary is-bold">
      <div class="hero-body">
        <div class="container">
          <h1 class="title has-text-centered">Create {{ content['novel_id'] }}</h1>
          <h2 class="subtitle has-text-centered">ตอนที่: {{ content.chapter }} </h2>
          <h2 class="subtitle has-text-centered">ผู้แปล: {{ content.author }} </h2>
          <h2 class="subtitle has-text-centered">ลงวันที่: {{ dateString(postDate.toDate()) }} </h2>
          <h2 class="subtitle has-text-centered">Facebook Caption: {{ content.caption }} </h2>
        </div>
      </div>
    </section>

    <section class="section">
      <b-field horizontal class="subtitle" label="Novel">
        <b-select placeholder="Select a novel" v-model="content['novel_id']">
            <option
                v-for="novel in this.$root.novels"
                :value="novel.id"
                :key="novel.id">
                {{ novel.name }}
            </option>
          </b-select>
          <b-input type="text" placeholder="xian-ni" v-model="content['novel_id']" disabled></b-input>
          <b-field>
          <p class="control">
            <b-dropdown v-model="content.status" hoverable>
                <button class="button is-primary" type="button" slot="trigger">
                    <template v-if="statusSetting('public')">
                        <b-icon icon="globe-asia"></b-icon>
                        <span>Publish</span>
                    </template>
                    <template v-else-if="statusSetting('scheduled')">
                        <b-icon icon="calendar-alt"></b-icon>
                        <span>Scheduled</span>
                    </template>
                    <template v-else-if="statusSetting('draft')">
                        <b-icon icon="save"></b-icon>
                        <span>Draft</span>
                    </template>
                    <template v-else>
                        <b-icon icon="edit"></b-icon>
                        <span>Update</span>
                    </template>
                    <b-icon icon="angle-down"></b-icon>
                </button>

                <b-dropdown-item value="public">
                  <div class="media">
                      <b-icon class="media-left" icon="globe-asia"></b-icon>
                      <div class="media-content">
                          <h3>Publish</h3>
                          <small>Publish now!</small>
                      </div>
                  </div>
                </b-dropdown-item>

                <b-dropdown-item value="scheduled">
                  <div class="media">
                    <b-icon class="media-left" icon="calendar-alt"></b-icon>
                    <div class="media-content">
                        <h3>Scheduled</h3>
                        <small>Publish when date fire!</small>
                    </div>
                  </div>
                </b-dropdown-item>

                <b-dropdown-item value="draft">
                  <div class="media">
                    <b-icon class="media-left" icon="save"></b-icon>
                    <div class="media-content">
                        <h3>Draft</h3>
                        <small>Save content to database</small>
                    </div>
                  </div>
                </b-dropdown-item>

                <b-dropdown-item value="update">
                  <div class="media">
                    <b-icon class="media-left" icon="edit"></b-icon>
                    <div class="media-content">
                        <h3>Update</h3>
                        <small>Update chapter content</small>
                    </div>
                  </div>
                </b-dropdown-item>
            </b-dropdown>
          </p>
        </b-field>
      </b-field>
      <b-field horizontal class="subtitle" label="Chapter">
          <b-input type="number" placeholder="000" v-model="content.chapter"></b-input>
          <button class="button is-primary is-fullwidth" :class="{ 'is-loading': isLoading }" @click="retrieveChapter">ดึงข้อมูล</button>
      </b-field>
      <b-field horizontal class="subtitle" label="Author">
          <b-input type="text" placeholder="keepwalk" v-model="content.author"></b-input>
      </b-field>
      <b-field horizontal class="subtitle" label="Date & Time">
        <b-datepicker placeholder="Type or select a date..." v-model="content.date">
        </b-datepicker>
        <b-timepicker placeholder="Click to select..." v-model="content.time">
          <button class="button is-primary" @click="setTimeSlot(9)">
            <b-icon icon="clock"></b-icon>
            <span>9:00</span>
          </button>
          <button class="button is-primary" @click="setTimeSlot(12)">
            <b-icon icon="clock"></b-icon>
            <span>12:00</span>
          </button>
          <button class="button is-primary" @click="setTimeSlot(15)">
            <b-icon icon="clock"></b-icon>
            <span>15:00</span>
          </button>
        </b-timepicker>
      </b-field>
      <b-field label="Caption" expanded>
        <b-input type="textarea" v-model="content.caption"></b-input>
      </b-field>
      <b-field position="is-right" expanded>
        <button class="button is-success is-fullwidth" :class="{ 'is-loading': isLoading }" @click="addPost">Save</button>
      </b-field>
      <div class="box">
        <wysiwyg v-model="content['post_content']" />
        <b-field grouped>
          <b-switch type="is-success" v-model="isPreview">Live Preview</b-switch>
        </b-field>
      </div>
    </section>

    <div class="content box" v-html="content['post_content']" v-show="isPreview">
    </div>
  </div>
</template>

<script>
import { db } from '@/firebase.config'
import { get } from 'vuex-pathify'
import { firebase } from '@firebase/app'

export default {
  name: 'create',
  data () {
    return {
      content: {
        status: '',
        'post_date': firebase.firestore.Timestamp.now(),
        'novel_id': 'xian-ni',
        'post_content': '',
        chapter: 1,
        author: '',
        caption: '',
        date: new Date(),
        time: new Date()
      },
      isPreview: false,
      isLoading: false
    }
  },
  computed: {
    postDate () {
      const contentDate = new Date()
      contentDate.setFullYear(this.content.date.getFullYear())
      contentDate.setMonth(this.content.date.getMonth())
      contentDate.setDate(this.content.date.getDate())
      contentDate.setHours(this.content.time.getHours())
      contentDate.setMinutes(this.content.time.getMinutes())
      contentDate.setSeconds(this.content.time.getSeconds())
      return firebase.firestore.Timestamp.fromDate(contentDate)
    },
    isAdmin: get('isAdmin')
  },
  methods: {
    addPost () {
      if (!this.isAdmin) {
        this.$root.$dialog.alert({
          title: 'เกิดข้อผิดพลาด',
          message: 'ท่านไม่มีสิทธิ์สร้างตอนใหม่',
          onConfirm: () => { this.$router.push('/') }
        })
        return
      }
      this.isLoading = true
      var key = `${this.content['novel_id']}-${this.content.chapter}`
      var chapter = {
        'novel_id': this.content['novel_id'],
        'chapter': parseInt(this.content.chapter),
        'post_content': this.content['post_content'],
        'status': this.content.status,
        'post_date': this.postDate,
        'author': this.content.author,
        'caption': this.content.caption ? this.content.caption : ''
      }
      var query = db.collection('chapters').doc(key)
      query
        .set(chapter)
        .then(docRef => {
          this.$root.$dialog.alert({
            title: 'สร้างสำเร็จ!',
            message: `สร้างตอน ${this.content.chapter} เรื่อง ${this.content['novel_id']} สำเร็จ!`
          })
          this.content.chapter++
          this.content['post_content'] = ''
          this.isLoading = false
        })
        .catch(error => {
          this.$root.$dialog.alert({ title: 'เกิดข้อผิดพลาด', message: error.message })
          this.isLoading = false
        })
    },
    dateString (date) {
      return date.toLocaleString('en-GB', { timeZone: 'Asia/Bangkok' })
    },
    setTimeSlot (hour) {
      const time = this.content['post_date'].toDate()
      time.setHours(hour)
      time.setMinutes(0)
      time.setSeconds(0)
      this.content.time = time
    },
    statusSetting (status) {
      return this.content.status === status
    },
    retrieveChapter () {
      this.isLoading = true
      var key = `${this.content['novel_id']}-${this.content.chapter}`
      var query = db.collection('chapters').doc(key)
      query.get()
        .then(snapshot => {
          const data = snapshot.data()
          this.content = {
            ...data,
            'date': data['post_date'].toDate(),
            'time': data['post_date'].toDate()
          }
          this.isLoading = false
        })
        .catch(error => {
          this.$root.$dialog.alert({ title: 'เกิดข้อผิดพลาด', message: error.message })
          this.isLoading = false
        })
    }
  },
  watch: {
    postDate (date) {
      const now = firebase.firestore.Timestamp.now()
      if (now < date) {
        this.content.status = 'scheduled'
      } else {
        this.content.status = 'public'
      }
    }
  }
}
</script>

<style lang="scss">
  .ql-align-center {
    text-align: center;
  }
  .hero-body {
    padding-left: 0%;
    padding-right: 0%;
    .content {
      padding-left: 2rem;
      padding-right: 2rem;
      padding-top: 2rem;
      padding-bottom: 2rem;
      border-radius: 0;
    }
  }
  ul {
    padding: 1.25rem;
  }
</style>
